export default {
  getStore: (state) => state.store,
};
